import { Lightbulb, ListChecks, Plus, Vote } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export type PlanSection = "ideas" | "polls" | "packing";

interface PlanActionBarProps {
  section: PlanSection;
  onNew: () => void;
}

/**
 * Bottom action bar for the Plan tab. Mirrors TripActionBar so the CTA
 * sits where users already look — right at the bottom, not scattered at
 * the top of each list. Copy adapts to the active sub-section.
 */
export function PlanActionBar({ section, onNew }: PlanActionBarProps) {
  const config =
    section === "ideas"
      ? { label: "New idea", Icon: Lightbulb }
      : section === "polls"
        ? { label: "New poll", Icon: Vote }
        : { label: "New packing item", Icon: ListChecks };

  return (
    <div
      // Sits ABOVE the trip's bottom tab bar (~64px + safe-area). The
      // tab bar owns bottom-0; this action bar stacks on top of it so
      // Plan's "new idea/poll/packing" CTA stays within thumb reach
      // without overlapping the tabs.
      data-ad-clip="bottom"
      className={cn(
        "fixed inset-x-0 z-20",
        "border-t border-line bg-[color-mix(in_oklab,var(--bg-elevated)_88%,transparent)]",
        "backdrop-blur-md",
      )}
      style={{ bottom: "calc(64px + var(--safe-bottom))" }}
    >
      <div className="mx-auto max-w-2xl px-5 pt-3 pb-3">
        <Button type="button" onClick={onNew} block size="lg">
          <Plus className="h-4 w-4" strokeWidth={2.5} />
          {config.label}
        </Button>
      </div>
    </div>
  );
}
